import request from '@/utils/http';

export default {
    // 查询列表
    getLists: (params) => {
        return request({
            url: `/api-otp/applyLog/selectListPage`,
            method: 'get',
            params
        });
    },
    saveItems: (data) => {
        return request({
            url: `/api-otp/applyLog/batchCreateOrUpdate`,
            method: 'post',
            data
        });
    },
    // 远程计费推bms
    sendJiFeiByNet: (data) => {
        return request({
            url: `/api-otp/net/sendJiFeiByNet`,
            method: 'post',
            data
        });
    }
};